import { FETCH_PRICING_REQUEST, FETCH_PRICING_SUCCESS, FETCH_PRICING_FAILURE, UPDATE_PRICING_REQUEST, UPDATE_PRICING_SUCCESS } from "../actions/PricingActions";

const initialState = {
    loading: true,
    pricings: [],
    error: "",
};

const pricingsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_PRICING_REQUEST:
        return { ...state, loading: true };
    case FETCH_PRICING_SUCCESS:
        return {
            ...state,
            loading: false,
            pricings: action.payload,
            error: "",
        };
    case FETCH_PRICING_FAILURE:
        return {
            ...state,
            loading: false,
            pricings: [],
            error: action.payload,
        };       
    case UPDATE_PRICING_REQUEST:
        return { 
            ...state, 
            payload: action.payload,
            loading: true
        };  
    case UPDATE_PRICING_SUCCESS:
        return {
            ...state,
            loading: false,
            html: action.payload,
            error: "",
            success: true
        };  
    default:
        return state;
    }
};

export default pricingsReducer;